import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

const ProgressIndicator = () => {
  const classes = useStyles();

  const isLoading = useSelector(state => state.cart.isLoading);

  const [open, setOpen] = useState(false);
  const [opening, setOpening] = useState(null);

  useEffect(
    () => {
      //console.log("ProgressIndicator", "useEffect", "isLoading", isLoading, "opening", opening, "open", open);
      if (isLoading && !opening && !open) {
        setOpen(false);
        var id = window.setTimeout(() => {
          //console.log("ProgressIndicator", "after 500ms", "set open to true");
          setOpen(true);
          setOpening(null);
        }, 500);
        setOpening(id);
      } else if (!isLoading) {
        if (opening) {
          //console.log("ProgressIndicator", "useEffect", "set opening to null");
          window.clearTimeout(opening);
          setOpening(null);
        }
        //console.log("ProgressIndicator", "useEffect", "set open to false");
        setOpen(false);
      }

      return () => {
        !opening || window.clearTimeout(opening);
      };
    },
    [isLoading],
  );

  //console.log("ProgressIndicator", "render", "isLoading", isLoading, "opening", opening, "open", open);

  //const handleClose = () => {
  //  setOpen(false);
  //};
  //const handleToggle = () => {
  //  setOpen(!open);
  //};

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Backdrop className={classes.backdrop} open={open} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}

export { ProgressIndicator }